import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { X } from "@phosphor-icons/react";

const STORAGE_KEY = "fitagenda_cookie_consent";

export default function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(() => {
    try {
      return !localStorage.getItem(STORAGE_KEY);
    } catch {
      return true;
    }
  });

  const accept = () => {
    try { localStorage.setItem(STORAGE_KEY, "accepted"); }
    catch (err) { console.warn("CookieBanner: cannot persist", err?.message); }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] border-t border-[#E30613]/40 bg-[#0A0A0A]/95 backdrop-blur-xl"
         data-testid="cookie-banner">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex-1 text-xs sm:text-sm text-zinc-300 leading-relaxed">
          <span className="font-bold text-white">🍪 {t("cookie.title")}</span>{" — "}
          {t("cookie.message")}{" "}
          <Link to="/legal/cookies" className="text-[#E30613] hover:text-white underline font-semibold" data-testid="cookie-link-policy">
            {t("cookie.learn_more")}
          </Link>
        </div>
        <button
          onClick={accept}
          className="shrink-0 bg-[#E30613] hover:bg-[#FF1A27] text-white text-xs uppercase tracking-[0.2em] font-bold px-6 py-3 rounded-none"
          data-testid="cookie-accept-button"
        >
          {t("cookie.accept")}
        </button>
        <button
          onClick={accept}
          aria-label="close"
          className="absolute md:relative top-3 right-3 md:top-0 md:right-0 text-zinc-500 hover:text-white"
          data-testid="cookie-close-button"
        >
          <X size={18} weight="bold" />
        </button>
      </div>
    </div>
  );
}
